module.exports = __webpack_public_path__ + "static/media/iris-logo.aea9a812.png";